import React from "react";
import moment from "moment";
import { ChatListItemProps } from "../../types/messages.types";
import { getName } from "../../utils/messageUtils";

const ChatListItem: React.FC<ChatListItemProps> = ({
  chat,
  isSelected,
  currentUser,
  onClick,
}) => {
  const otherUser =
    currentUser?.id === chat.sender?.id ? chat.receiver : chat.sender;
  const userName = otherUser?.name || "User";
  const userImage = otherUser?.image;

  const property = chat.property;
  
  const isSharedProperty = 
    property?.is_shared_property === true || 
    property?.total_rooms > 1;

 // const roomInfo = chat.booking_query?.booked_room || null;

  const chatData = chat as any;
const roomInfo = 
  chatData.booking_query?.booked_room ||  // From inquiry (before accepted)
  chatData.booking?.booked_room ||        // From booking (after accepted)
  null;

  console.log("=== CHAT LIST ITEM DEBUG ===");
  console.log("Chat ID:", chat.id);
  console.log("Full chat object:", chat);
  console.log("Property:", property);
  console.log("Property keys:", property ? Object.keys(property) : "No property");
  console.log("is_shared_property:", property?.is_shared_property);
  console.log("total_rooms:", property?.total_rooms);
  console.log("isSharedProperty (computed):", isSharedProperty);
  console.log("booking_query:", chat.booking_query);
  console.log("booked_room:", chat.booking_query?.booked_room);
  console.log("roomInfo (computed):", roomInfo);
  console.log("Will show room info?", isSharedProperty && roomInfo);
  console.log("============================");

  const getLastMessagePreview = () => {
    if (!chat.last_message) return "No messages yet";
    const messageText = chat.last_message;
    return messageText.length > 50
      ? messageText.substring(0, 50) + "..."
      : messageText;
  };

  

const getTimeDisplay = () => {
  if (!chat.last_message_time) return "";
  return moment.utc(chat.last_message_time).local().fromNow(); 
};

  return (
    <div
      onClick={() => onClick(chat)}
      className={`flex items-center gap-3 p-4 cursor-pointer transition-all border-l-4 ${
        isSelected
          ? "bg-[#F56948]/10 border-[#F56948] dark:bg-[#F56948]/20"
          : "bg-white hover:bg-neutral-50 border-transparent dark:bg-neutral-800 dark:hover:bg-neutral-700"
      }`}
    >
      <div className="relative flex-shrink-0">
        {userImage ? (
          <img
            src={userImage}
            alt={userName}
            className="w-12 h-12 rounded-full object-cover ring-2 ring-neutral-200 dark:ring-neutral-600"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#F56948] to-[#E5593D] flex items-center justify-center text-white font-bold">
            {userName?.charAt(0)?.toUpperCase() || "?"}
          </div>
        )}
        {/* Online presence dot */}
        <div
          className={`absolute bottom-0 right-0 w-3 h-3 rounded-full ring-2 ring-white dark:ring-neutral-800 ${
            (otherUser as any)?.is_online ? "bg-green-500" : "bg-neutral-400"
          }`}
        />
        {chat.unread_count > 0 && (
          <div className="absolute -top-1 -right-1 bg-[#F56948] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {chat.unread_count > 9 ? "9+" : chat.unread_count}
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h4
            className={`font-semibold truncate ${
              chat.unread_count > 0
                ? "text-neutral-900 dark:text-white"
                : "text-neutral-700 dark:text-neutral-300"
            }`}
          >
            {getName(userName)}
          </h4>
          <span className="text-xs text-neutral-500 dark:text-neutral-400 flex-shrink-0 ml-2">
            {getTimeDisplay()}
          </span>
        </div>

        {chat.property && (
          <p className="text-xs text-neutral-600 dark:text-neutral-400 truncate mb-1">
            📍 {property.title}
            {isSharedProperty && !roomInfo && property.total_rooms > 1 && (
              <span className="ml-1.5 text-blue-600 dark:text-blue-400 font-medium">
                • {property.total_rooms} rooms
              </span>
            )}
          </p>
        )}

        {isSharedProperty && roomInfo && (
          <div className="flex items-center gap-1 mb-1">
            <span className="text-xs font-medium text-blue-600 dark:text-blue-400 truncate">
              🚪 {roomInfo.name}
            </span>
          </div>
        )}

        <p
          className={`text-sm truncate ${
            chat.unread_count > 0
              ? "text-neutral-700 dark:text-neutral-300 font-medium"
              : "text-neutral-500 dark:text-neutral-400"
          }`}
        >
          {getLastMessagePreview()}
        </p>
      </div>
    </div>
  );
};

export default ChatListItem;